<template>
  <router-link
    :to="{ name }"
    class="nav-link"
  >
    <i :class="icon" /> {{ title }}
    <b-badge
      v-if="typeof badge.text !== 'undefined'"
      :variant="badge.variant"
    >
      {{ badge.text }}
    </b-badge>
  </router-link>
</template>

<script>
export default {
  name: 'AppSidebarNavLink',
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    badge: {
      type: String,
      default: '',
    },
  },
};
</script>
